import { all, takeLatest } from 'lib/redux';
import {
  LOAD_REPORT_DETAILS_PAGE,
  LOAD_REPORT_ADDRESSES,
} from 'constants/ActionTypes';
import { loadReportAddressesSaga, loadReportDetailsSaga } from './ReportDetailsPage.saga';

/**
 * Defines the watchers related to ReportDetails Page.
 * These watchers will be imported in store/RootSaga.js
 */
export default function* watchers() {
  yield all([
    takeLatest(LOAD_REPORT_ADDRESSES, loadReportAddressesSaga),
    takeLatest(LOAD_REPORT_DETAILS_PAGE, loadReportDetailsSaga),
  ]);
}
